import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, ChevronLeft } from 'lucide-react';
import api from '../services/api.js';
import toast from 'react-hot-toast';

export default function ForgotPasswordPage() {
  const [email, setEmail]     = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent]       = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post('/auth/forgot-password', { email });
      setSent(true);
    } catch {
      // Always show success to prevent email enumeration
      setSent(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      {/* Background grid */}
      <div className="fixed inset-0 pointer-events-none" style={{
        backgroundImage: `linear-gradient(rgba(0,212,255,0.03) 1px, transparent 1px),
                          linear-gradient(90deg, rgba(0,212,255,0.03) 1px, transparent 1px)`,
        backgroundSize: '60px 60px',
      }} />

      <div className="w-full max-w-md relative animate-slide-up">
        <div className="text-center mb-8">
          <div className="text-6xl mb-3" style={{ filter: 'drop-shadow(0 0 20px rgba(0,212,255,0.4))' }}>🏟</div>
          <h1 className="section-title text-4xl" style={{ color: 'var(--ice)' }}>Game Day</h1>
        </div>

        <div className="zen-card p-8">
          {sent ? (
            <div className="text-center py-4">
              <div className="text-5xl mb-4">📧</div>
              <h2 className="text-xl font-bold mb-3">Check your inbox</h2>
              <p className="text-secondary text-sm leading-relaxed mb-6">
                If that email is registered, you'll receive password reset instructions within a few minutes.
              </p>
              <Link to="/login" className="btn-ice mx-auto">
                <ChevronLeft size={15} /> Back to Sign In
              </Link>
            </div>
          ) : (
            <>
              <Link to="/login" className="btn-ghost text-sm mb-5 -ml-2 inline-flex">
                <ChevronLeft size={14} /> Back to Sign In
              </Link>
              <h2 className="text-2xl font-bold mb-2">Forgot Password</h2>
              <p className="text-secondary text-sm mb-6">
                Enter your email and we'll send you a reset link.
              </p>
              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <label className="label">Email Address</label>
                  <div className="relative">
                    <Mail size={15} className="absolute left-3 top-3.5 text-secondary" />
                    <input
                      type="email" required
                      className="input-field pl-9"
                      placeholder="you@example.com"
                      value={email}
                      onChange={e => setEmail(e.target.value)}
                      autoComplete="email"
                    />
                  </div>
                </div>
                <button type="submit" disabled={loading} className="btn-ice w-full justify-center py-3">
                  {loading ? <div className="spinner" style={{ width: 16, height: 16 }} /> : 'Send Reset Link'}
                </button>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
